// See https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
export const shuffleArray = <T>(array: T[]) => {
    const array_copy = [...array];
    for (let i = array_copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array_copy[i], array_copy[j]] = [array_copy[j], array_copy[i]];
    }
    return array_copy;
};
